module.exports = __webpack_public_path__ + "img/account.7dc082da.svg";